import { supabase } from './supabase'

interface LogSearchParams {
  orderId: string
  method: 'manual' | 'scanner' | 'pickup_code'
}

export async function logSearch({ orderId, method }: LogSearchParams) {
  try {
    const { data: { user }, error: authError } = await supabase.auth.getUser()
    if (authError) {
      console.error('[logSearch] Auth error:', authError.message)
      return
    }
    if (!user?.id) {
      console.error('[logSearch] No user found')
      return
    }

    // Get user's current organization
    const { data: membership, error: memberError } = await supabase
      .schema('core')
      .from('organization_members')
      .select('organization_id')
      .eq('user_id', user.id)
      .eq('is_current', true)
      .single()

    if (memberError) {
      console.error('[logSearch] Membership error:', memberError.message)
      return
    }

    if (!membership?.organization_id) {
      console.error('[logSearch] No organization found for user')
      return
    }

    console.log('[logSearch] Logging search:', { orderId, method, org: membership.organization_id })

    const { error: insertError } = await supabase.schema('logging').from('usage_logs').insert({
      organization_id: membership.organization_id,
      user_id: user.id,
      app_name: 'utlevering',
      action: 'SEARCH',
      entity_type: 'order',
      app_data: { method, order_id: orderId },
    })

    if (insertError) {
      console.error('[logSearch] Insert error:', insertError.message)
    } else {
      console.log('[logSearch] Search logged successfully')
    }
  } catch (err) {
    console.error('[logSearch] Unexpected error:', err)
  }
}
